<template>
  <div>
    <div v-if="hasAuth">
      <el-row :gutter="4" class="mr-b4">
        <el-col :span="12">
          <el-button style="width:100%;" type="secondary" size="small" @click="onClickExecuteDeviceInfoUpdate">장비 정보 업데이트</el-button>
        </el-col>
        <el-col :span="12">
          <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
        </el-col>
      </el-row>
      <el-row :gutter="4" class="mr-b4">
        <el-col :span="12">
          <w-collection-judgement-rule-popup-button :obj-info="objInfo"></w-collection-judgement-rule-popup-button>
        </el-col>
        <el-col :span="12">
          <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
        </el-col>
      </el-row>
      <el-row :gutter="4" class="mr-b25">
        <!-- <el-col :span="12">
          <w-common-script-popup-button :obj-info="objInfo"></w-common-script-popup-button>
        </el-col> -->
        <el-col :span="12">
          <w-simulation-predict-popup-button :obj="objInfo" />
        </el-col>
      </el-row>
      <!-- <div class="title-h4 title-bar">WatchAll 관리도구</div> -->
      <!-- <el-button class="mr-b25"  @click="onClickOpenRealtimeControlPopup" style="width:100%;" size="small" type="primary">실시간 제어</el-button> -->
      <w-server-realtime-control-popup ref="serverRealtimeControlPopup"/>
      <!-- <div class="title-h4 title-bar">Agent 원격 제어</div>
      <el-row :gutter="4" class="mr-b25">
        <el-col :span="8"><el-button style="width:100%;" @click="onClickExecuteAgentStart" size="small"><i class="fas fa-play-circle text-14 mr-r4"/>시작</el-button></el-col>
        <el-col :span="8"><el-button style="width:100%;" @click="onClickExecuteAgentStop" size="small"><i class="fas fa-pause-circle text-14 mr-r4" />중지</el-button></el-col>
        <el-col :span="8"><el-button style="width:100%;" @click="onClickExecuteReStart" size="small"><i class="far fa-sync-alt mr-r4" style="font-size: 12px" />재기동</el-button></el-col>
      </el-row> -->
      <w-basic-sliding-button-group :obj-info="objInfo" />
    </div>
    <div v-else>
      <el-row :gutter="4" class="mr-b4">
        <el-col :span="12">
          <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
        </el-col>
        <el-col :span="12">
          <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
        </el-col>
      </el-row>
      <el-row :gutter="4">
        <el-col :span="12">
          <w-simulation-predict-popup-button :obj="objInfo" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import serverTableInfoAPI from '@/api/performance/server/info-table';
import HambugerPopupMixin from '@/mixins/performance/hambuger-popup';
import WBasicSlidingButtonGroup from './BasicSlidingButtonGroup';
import WCommonSettingChartTypePopupButton from './CommonSettingChartTypePopupButton';
import WCommonScriptPopupButton from './CommonScriptPopupButton';
import WServerRealtimeControlPopup from './ServerRealtimeControlPopup';
import WCollectionJudgementRulePopupButton from './CollectionJudgementRulePopupButton';
import WEventAlarmRulePopupButton from './EventAlarmRulePopupButton';
import WSimulationPredictPopupButton from './button/common/SimulationPredictPopupButton';

export default {
  name: 'WServerSlidingButtonGroup',
  components: {
    WBasicSlidingButtonGroup,
    WCommonSettingChartTypePopupButton,
    WCommonScriptPopupButton,
    WServerRealtimeControlPopup,
    WCollectionJudgementRulePopupButton,
    WEventAlarmRulePopupButton,
    WSimulationPredictPopupButton,
  },
  mixins: [HambugerPopupMixin],
  data() {
    return {
      agentExecuteType: {
        START: 'AGENTRUN',
        STOP: 'AGENTSTOP',
        RE_START: 'AGENTRESTART',
      },
      agentRemoteControlParams: {
        executeType: '',
        targetList: [],
      },
    };
  },
  methods: {
    /**
     * [onClickExecuteAgentStart agent 원격 제어 시작]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExecuteAgentStart() {
      this.agentRemoteControlParams.executeType = this.agentExecuteType.START;
      const ipaddress = this.objInfo.obj.ipaddressApplytype === 'IPv4' ? this.objInfo.obj.ipaddressIpv4 : this.objInfo.obj.ipaddressIpv6;
      this.agentRemoteControlParams.targetList = [({ objId: this.objInfo.obj.objId, objIp: ipaddress })];
      serverTableInfoAPI
        .executeServerAgentRemoteControl(this.agentRemoteControlParams)
        .then((result) => {
          if (result.data.success === true) {
            this.notification('Agent 원격 제어 시작');
          }
        });
    },
    /**
     * [onClickExecuteAgentStop agent 원격 제어 정지]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExecuteAgentStop() {
      this.agentRemoteControlParams.executeType = this.agentExecuteType.STOP;
      const ipaddress = this.objInfo.obj.ipaddressApplytype === 'IPv4' ? this.objInfo.obj.ipaddressIpv4 : this.objInfo.obj.ipaddressIpv6;
      this.agentRemoteControlParams.targetList = [({ objId: this.objInfo.obj.objId, objIp: ipaddress })];
      serverTableInfoAPI
        .executeServerAgentRemoteControl(this.agentRemoteControlParams)
        .then((result) => {
          if (result.data.success === true) {
            this.notification('Agent 원격 제어 중지');
            this.onClearParams();
          }
        });
    },
    /**
     * [onClickExecuteReStart agent 원격제어 재시작]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExecuteReStart() {
      this.agentRemoteControlParams.executeType = this.agentExecuteType.RE_START;
      const ipaddress = this.objInfo.obj.ipaddressApplytype === 'IPv4' ? this.objInfo.obj.ipaddressIpv4 : this.objInfo.obj.ipaddressIpv6;
      this.agentRemoteControlParams.targetList = [({ objId: this.objInfo.obj.objId, objIp: ipaddress })];
      serverTableInfoAPI
        .executeServerAgentRemoteControl(this.agentRemoteControlParams)
        .then((result) => {
          if (result.data.success === true) {
            this.notification('Agent 원격 제어 재기동');
            this.onClearParams();
          }
        });
    },
    /**
     * [onClickExecuteDeviceInfoUpdate 장비정보 업데이트]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExecuteDeviceInfoUpdate() {
      serverTableInfoAPI
        .executeDeviceInfoUpdate({ objId: this.objInfo.obj.objId })
        .then((result) => {
          if (result.data.success === true) {
            this.notification('장비 정보 업데이트');
            this.onClearParams();
          }
        });
    },
    /**
     * [notification 수행완료 notify]
     * @author {Yang}
     * @param  {[type]} title [description]
     * @return {[type]}       [description]
     */
    notification(title) {
      this.$notify({
        title,
        customClass: 'center',
        message: `${this.objInfo.obj.objName}에 대한 ${title}를 수행하였습니다.`,
        duration: 2000,
      });
    },
    /**
     * [onClickOpenRealtimeControlPopup 실시간 제어 슬라이딩 팝업 open]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickOpenRealtimeControlPopup() {
      this.$refs.serverRealtimeControlPopup.openPopup();
    },
    onClearParams() {
      this.agentRemoteControlParams.executeType = '';
      this.agentRemoteControlParams.targetList = [];
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ServerSlidingButtonGroup.vue